module.exports = __webpack_public_path__ + "static/media/ar_logo_black.e48ca792.png";